module.exports = __webpack_public_path__ + "aa346c0ede559d3a5d58e55c0932029b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/coinbox.png
// module id = 755
// module chunks = 0